import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: {
    id: 'growthChartsLanding.pageTitle',
    defaultMessage: 'Free Child Growth Charts — WHO Standards | Sijilo'
  },
  metaDescription: {
    id: 'growthChartsLanding.metaDescription',
    defaultMessage:
      "Plot your child's weight, height, head circumference, and BMI on WHO growth charts. Free tool, no account needed."
  },
  heroHeadline: {
    id: 'growthChartsLanding.heroHeadline',
    defaultMessage: 'Free Child Growth Charts'
  },
  heroSubheadline: {
    id: 'growthChartsLanding.heroSubheadline',
    defaultMessage:
      'Plot weight, height, head circumference, and BMI on WHO percentile curves. No account needed.'
  },
  patientInfoTitle: {
    id: 'growthChartsLanding.patientInfoTitle',
    defaultMessage: 'Child Information'
  },
  sexLabel: {
    id: 'growthChartsLanding.sexLabel',
    defaultMessage: 'Sex'
  },
  male: {
    id: 'growthChartsLanding.male',
    defaultMessage: '♂ Boy'
  },
  female: {
    id: 'growthChartsLanding.female',
    defaultMessage: '♀ Girl'
  },
  dobLabel: {
    id: 'growthChartsLanding.dobLabel',
    defaultMessage: 'Date of Birth'
  },
  measurementsTitle: {
    id: 'growthChartsLanding.measurementsTitle',
    defaultMessage: 'Measurements'
  },
  dateColumn: {
    id: 'growthChartsLanding.dateColumn',
    defaultMessage: 'Date'
  },
  weightColumn: {
    id: 'growthChartsLanding.weightColumn',
    defaultMessage: 'Weight (kg)'
  },
  heightColumn: {
    id: 'growthChartsLanding.heightColumn',
    defaultMessage: 'Height (cm)'
  },
  ofcColumn: {
    id: 'growthChartsLanding.ofcColumn',
    defaultMessage: 'Head Circ. (cm)'
  },
  addRow: {
    id: 'growthChartsLanding.addRow',
    defaultMessage: '+ Add measurement'
  },
  removeRow: {
    id: 'growthChartsLanding.removeRow',
    defaultMessage: 'Remove'
  },
  clearAll: {
    id: 'growthChartsLanding.clearAll',
    defaultMessage: 'Clear all'
  },
  chartTitle: {
    id: 'growthChartsLanding.chartTitle',
    defaultMessage: 'Growth Chart'
  },
  ctaHeadline: {
    id: 'growthChartsLanding.ctaHeadline',
    defaultMessage: 'Track your patients with Sijilo'
  },
  ctaDescription: {
    id: 'growthChartsLanding.ctaDescription',
    defaultMessage:
      'Sijilo is a clinic management platform that keeps all patient records, growth data, and visits in one place.'
  },
  ctaButton: {
    id: 'growthChartsLanding.ctaButton',
    defaultMessage: 'Book a Demo →'
  },
  navLogin: {
    id: 'growthChartsLanding.navLogin',
    defaultMessage: 'Log in'
  }
})
